import React from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { SaleRow } from "app/types/service-types/SalesTypes";
import AppUtils from "../../../utils/AppUtils";
import DateUtils from "app/utils/DateUtils";

export const SalesTableRow: React.FC<{ row: SaleRow }> = ({ row }) => {
  return (
    <TableRow hover>
      <TableCell align="center">
        {row.bookingDateTime
          ? DateUtils.formatDateTime(row.bookingDateTime)
          : " "}
      </TableCell>
      <TableCell align="center">{row.bookingNumber}</TableCell>
      <TableCell align="center">{row.passenger}</TableCell>
      <TableCell align="center">{row.departureFlightLabel}</TableCell>
      <TableCell align="center">{row.returnFlightLabel}</TableCell>
      <TableCell align="center">
        {row.departureDate
          ? DateUtils.formatDateTime(row.departureDate)
          : " "}
      </TableCell>
      <TableCell align="center">
        {row.returningDate
          ? DateUtils.formatDateTime(row.returningDate)
          : " "}
      </TableCell>
      <TableCell align="center">{AppUtils.formatMoney(row.departureTicketPrice)}</TableCell>
      <TableCell align="center">{AppUtils.formatMoney(row.returnTicketPrice)}</TableCell>
      <TableCell align="center">{AppUtils.formatMoney(row.seatSelectionCost)}</TableCell>
      <TableCell align="center">{AppUtils.formatMoney(row.baggageCost)}</TableCell>
      <TableCell align="center">{AppUtils.formatMoney(row.total)}</TableCell>
      <TableCell align="center">{AppUtils.formatMoney(row.commission)}</TableCell>
      <TableCell align="center">{AppUtils.formatMoney(row.netAmount)}</TableCell>
    </TableRow>
  );
};
